import { render, staticRenderFns } from "./ProfitabilityCategoryEvolution.vue?vue&type=template&id=5d2a67cb&scoped=true"
import script from "./ProfitabilityCategoryEvolution.vue?vue&type=script&lang=js"
export * from "./ProfitabilityCategoryEvolution.vue?vue&type=script&lang=js"
import style0 from "./ProfitabilityCategoryEvolution.vue?vue&type=style&index=0&id=5d2a67cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2a67cb",
  null
  
)

export default component.exports